import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { CallCenterAgent } from '@business/call-center/call-center-agent/models/call-center-agent';
import { NewCallCenterAgent } from '@business/call-center/call-center-agent/models/new-call-center-agent';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CallCenterAgentRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(callCenterId: number, agents: NewCallCenterAgent[]): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/agents`).pipe(
      mergeMap((url) => this.http.post<void>(url, agents)),
      wrapError('call-center-agent-repository:add')
    );
  }

  delete(callCenterId: number, id: number): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/agent/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('call-center-agent-repository:delete')
    );
  }

  get(callCenterId: number, id: string): Observable<CallCenterAgent> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/agent/${id}`).pipe(
      mergeMap((url) => this.http.get<CallCenterAgent>(url)),
      wrapError('call-center-agent-repository:get')
    );
  }

  list(callCenterId: number): Observable<CallCenterAgent[]> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/agent`).pipe(
      mergeMap((url) => this.http.get<CallCenterAgent[]>(url)),
      wrapError('call-center-agent-repository:list')
    );
  }

  update(callCenterId: number, callCenterAgent: CallCenterAgent): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/agent/${callCenterAgent.id}`).pipe(
      mergeMap((url) => this.http.put<void>(url, callCenterAgent)),
      wrapError('call-center-agent-repository:update')
    );
  }
}
